var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.56 35.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e50012;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.56,28.68c0,3.98-3.24,7.22-7.22,7.22H7.23c-3.99,0-7.23-3.24-7.23-7.22V7.23C0,3.24,3.24,0,7.23,0h54.11c3.99,0,7.22,3.24,7.22,7.23v21.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.78,20.46q1.09-1.21,2.32-2.65l5.23-6.13c1.16-1.33,1.62-1.93,2.24-2.87h4.94c-.15,1.42-.19,2.39-.19,4v7.84h.7c.75,0,1.54-.07,2.39-.19v4.39c-.72-.1-1.62-.14-2.36-.14h-.72v1.21c0,1.35.05,2.05.19,2.97h-4.97c.12-.82.19-1.83.19-3.02v-1.18h-6.82c-1.57,0-2.24.02-3.14.1v-4.32ZM52.76,17.91c0-1.09.05-2.41.15-3.47-.48.68-.84,1.16-1.5,1.98l-3.52,4.29h4.87v-2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.92,
    y: 4.53,
    width: 26.84,
    height: 26.84,
    rx: 3.4,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.85,21.21h-5.32v7.1h-4.54V8.82l9.52.02c2.12,0,3.77.54,4.93,1.63,1.1,1.04,1.65,2.45,1.65,4.25s-.48,3.33-1.43,4.5c-1.1,1.33-2.71,1.99-4.81,1.99M22.12,12.44h-4.59v5.23h4.47c.84,0,1.51-.25,1.99-.75.49-.5.73-1.21.73-2.14,0-1.56-.87-2.33-2.6-2.33"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4);
export default __webpack_public_path__ + "static/media/p4.e5130c701007305bbaf2067685095ca4.svg";
export { ForwardRef as ReactComponent };